<script lang="ts" setup>
const props = defineProps<{
  warning: string
}>()
const useGhostIcon = computed(() => {
  return props.warning?.includes('not bookable')
})
const classes = 'ml-1 text-xs opacity-70'
</script>

<template>
  <i-mdi:ghost v-if="useGhostIcon" :class="classes" />
  <i-mdi:alert v-else v-tooltip="warning" :class="classes" />
</template>
